import { createAsyncThunk } from '@reduxjs/toolkit'
import { PARAMETER_MANAGEMENT_CRUD } from '../../Constants/ApiDefinations'
import {
  createParameterReqData,
  parameterCRUDAPIDefinitionModal,
  parameterStatusChangeDefinitionModal,
} from '../../Models'
import mainApiService from '../../Services'
import { setLoader } from './loader.slice'

export const deleteParameter = createAsyncThunk(
  'parameter/deleteParameter',
  async (id: string, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: parameterCRUDAPIDefinitionModal =
      PARAMETER_MANAGEMENT_CRUD.DELETE_PARAMETER(id)
    const data = await mainApiService(requestedData)
    dispatch(setLoader(false))

    return data
  },
)

export const createParameterService = createAsyncThunk(
  'parameter/createPrameter',
  async (payload: createParameterReqData, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: parameterCRUDAPIDefinitionModal =
      PARAMETER_MANAGEMENT_CRUD.CREATE_PARAMETER(payload)
    const data = await mainApiService(requestedData)
    dispatch(setLoader(false))

    return data
  },
)

export const updateParameterService = createAsyncThunk(
  'Parameter/updateParameter',
  async (payload: createParameterReqData, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: parameterCRUDAPIDefinitionModal =
      PARAMETER_MANAGEMENT_CRUD.UPDATE_PARAMETER(payload)
    const data = await mainApiService(requestedData)
    dispatch(setLoader(false))

    return data
  },
)

export const changeStatus = createAsyncThunk(
  'parameter/changeStatus',
  async (data: { parameterId: string; status: string }, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: parameterStatusChangeDefinitionModal =
      PARAMETER_MANAGEMENT_CRUD.CHANGE_STATUS(data)
    const result = await mainApiService(requestedData)
    dispatch(setLoader(false))
    return result
  },
)

export const viewParameterService = createAsyncThunk(
  'parameter/viewParameter',
  async (id: string, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = PARAMETER_MANAGEMENT_CRUD.VIEW_PARAMETER(id)
    const data = await mainApiService(requestedData)
    dispatch(setLoader(false))

    return data
  },
)
